import React from "react";

export default function SceneControls({
  autoRotate,
  setAutoRotate,
  resetModel,
}) {
  return (
    <>
      <button
        type="button"

        className={
          autoRotate ? "reconstruction-button active" : "reconstruction-button"
        }

        onClick={() => setAutoRotate(!autoRotate)}
      >
        AUTO ROTATE
      </button>

      <button
        type="button"

        className="reconstruction-button"

        onClick={resetModel}
      >
        RESET MODEL
      </button>
    </>
  );
}
